import { render, staticRenderFns } from "./PageExplanation.vue?vue&type=template&id=609a93af&scoped=true"
import script from "./PageExplanation.vue?vue&type=script&lang=ts"
export * from "./PageExplanation.vue?vue&type=script&lang=ts"
import style0 from "./PageExplanation.vue?vue&type=style&index=0&id=609a93af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609a93af",
  null
  
)

export default component.exports